import { render, staticRenderFns } from "./chooseCourseModule.vue?vue&type=template&id=fd1590ca&scoped=true"
import script from "./chooseCourseModule.vue?vue&type=script&lang=ts"
export * from "./chooseCourseModule.vue?vue&type=script&lang=ts"
import style0 from "./chooseCourseModule.vue?vue&type=style&index=0&id=fd1590ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1590ca",
  null
  
)

export default component.exports